import {
  Select
} from 'antd';
import React from "react";
const Option = Select.Option;

/**
 * 页面加载时，根据数据字典获取下拉框option
 * @param data  数据字典集合
 * @param key   当前数据字典的key值  如 TYPE_SEX
 * @param exArr 禁用的项
 */
export function getOptionsByDictionary(data,key,exArr=[]){
  //

  let options =[];
  const dictonary = data[key];
  if(dictonary&&dictonary.length){
    dictonary.forEach( node => {
      const k = node.attrCode;
      const t = node.attrValue;
      if(exArr.includes(k)){
        options.push(<Option value={k} key={k} disabled>{t}</Option>);
      }else{
        options.push(<Option value={k} key={k}>{t}</Option>);
      }
    });
  }
  return options;
}
/**
 * 转换字典  获取相应的value
 *
 * */
export function changeByDictionary(value,dictionaryName,reactElem){

  let {dictionary}=reactElem.props;
  if(dictionary &&dictionary.posts){
    let allDate=dictionary.posts.dictionaryMap[dictionaryName]||[];
    for(let i=0;i<allDate.length;i++){
      let dataN=allDate[i];
      const k = dataN.attrCode;
      const t = dataN.attrValue;
      if(k==value){
        return t
      }
    }
  }
  return ''

};
/**
 * 转换币种  获取相应的value
 *
 * */
export function changeByCurrency(key,currency,selectedLang,reactElem){
  for(let i=0;i<currency.length;i++){
    let currencyN=currency[i];
    let {currencyId,currencyEname,currencyName}=currencyN;
    if(key==currencyId){
      return  selectedLang&&selectedLang=='en-US'? currencyEname:currencyName;
    }
  }
  return ''

};

